import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface ServiceStateBadgeProps {
    state: string;
}

export const ServiceStateBadge: FC<ServiceStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('service-state.active'),
        inactiveLabel: t('service-state.inactive'),
        pendingLabel: t('service-state.pending'),
        rejectedLabel: t('service-state.rejected'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light " />;
        case 'pending':
            return <Badge label={translations.pendingLabel} type={BadgeType.warning} icon="fa-light fa-gear" />;
        case 'rejected':
            return <Badge label={translations.rejectedLabel} type={BadgeType.info} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
